<!--
 * @Author: ghy
 * @Date: 2023-07-18 12:25:21
 * @LastEditors: ghy
 * @LastEditTime: 2023-08-08 09:44:26
 * @Description: 
-->
<template>
  <div class="cus-header">
    <div class="cus-header-content">
      <div class="cus-text">北京市中小学校办学条件管理系统</div>
      <div class="cus-search">
        <el-input size="" placeholder="请输入内容" v-model="input">
          <el-button
            @click="globalSearch"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
import { globalSearch } from "@/api/search";
export default {
  name: "CusHeader",
  data() {
    return {
      input: "",
    };
  },
  methods: {
    async globalSearch() {
      if(!this.input){
        this.$message({
          message: '必须输入条件方可检索',
          type: 'warning'
        });
        return
      }
      const res = await globalSearch({
        title: this.input,
        orderSort:this.orderSort
      });
      const gwSearch = res.data.gwSearch;
     // this.$EventBus.$emit("searchValue", this.input);
      //this.$EventBus.$emit("gwSearch", gwSearch);
      
      this.$store.commit("getGwSearch", gwSearch)
      this.$store.commit("getSearchValue", this.input)
      this.$router.push({ path: "/searchList" }, () => {});
      
    },
  },
};
</script>

<style lang="less" scoped>
.cus-header {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 84px;
  background: #bd1a2d;
}
.cus-header-content {
  width: 1400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cus-text {
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 21px;
  margin-left: 128px;
  text-shadow: 3px 3px 5px #000;
}
.cus-search {
  width: 456px;
  margin-right: 128px;
}
/deep/ .el-icon-search {
  color: #1079e1 !important;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/CusHeader.vue